import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './usereditpage.cssmodule.scss';
import { Radio, FormGroup, Panel, Collapse, Well, Alert} from 'react-bootstrap';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import UserSelect from '../Shared/UserSelect';
import Select from 'react-select';

class UserEditPage extends React.Component {

  constructor(props) {
    super(props);
    const { userId } = props;
    const currentEditUser = this.props.currentEditUser.User;
    this.state = {
      userId: userId,
      user : {...currentEditUser}
    }
  }

  componentDidMount() {
    const { userId } = this.props;
    const currentEditUser = this.props.currentEditUser.User;
    this.setState({
      userId: userId,
      user : {...currentEditUser}
    });
    
  }

  componentDidUpdate(prevProps) {

  }

  componentWillReceiveProps(nextProps) { 
    const { userId } = nextProps;
    const currentEditUser = nextProps.currentEditUser.User;
    this.setState({
      userId: userId,
      user : {...currentEditUser}
    });
  }

  handleCipGroupSelect(cipGroup){
    let user = Object.assign(this.state.user, 
          {CipGroupId : cipGroup ? cipGroup.Id : 0}
    );

    this.setState({
      user : user
    });
  }

  saveUserClick(){
    const { onSaveUser } = this.props;
    if(onSaveUser){
      onSaveUser(this.state.user).catch((exp) => {
          this.setState({
            errorOpen : true,
            errorMessage : exp.Message
          });
          //hide message
          setTimeout(() => {
            this.setState({
              errorOpen : false
            });
          }, 4000);
      });
    }
  }

  handleInputChange(propertyName, event){
   
    var value = typeof event === 'object' ? event.target.value : event;
    if(propertyName === 'IsAdmin' || propertyName === 'IsActive'){
       value = event.target.checked ? true : false;
    }

    let user = Object.assign(this.state.user, 
          {[propertyName] : value}
    );
    this.setState({
      user : user
    });
  }

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { cipGroups } = this.props;
    const currentEditUser = this.props.currentEditUser.User;
    const { userId } = this.props;
    const managerName = (currentEditUser.Manager ? currentEditUser.Manager.DisplayName : '');
    var stateUser = this.state.user;
    const { authInfo } = this.props;
    const { IsAdmin } = this.props;
    const Authorized = IsAdmin || (authInfo.LocalInfo && authInfo.LocalInfo.Id == userId);
    return (
      <div className="container usereditpage-component" styleName="usereditpage-component">
        <Panel header={t('User') + ' #' + userId} className="brand-panel">
          <form className="form-condensed">
              <div className="form-group">
                  <label>* {t('Account')}</label>
                  <input disabled="true" className="form-control" value={stateUser.Account || ''} onChange={this.handleInputChange.bind(this, 'Account')}/>
              </div>

              <div className="form-group">
                  <label>{t('Country')}</label>
                  <input disabled="true" className="form-control" value={stateUser.CountryCode || ''} />
              </div>

               <div className="form-group">
                  <label>{t('Domain')}</label>
                  <input disabled={!Authorized}  className="form-control" value={stateUser.Domain || '' } onChange={this.handleInputChange.bind(this, 'Domain')}/>
              </div>
             <div className="form-group">
                  <label>{t('Email')}</label>
                  <input disabled={!Authorized}  className="form-control" type="email" value={stateUser.Email || ''} onChange={this.handleInputChange.bind(this, 'Email')}/>
              </div>
               <div className="form-group">
                  <label>* {t('Display Name')}</label>
                  <input disabled={!Authorized}  className="form-control" value={stateUser.DisplayName || ''} onChange={this.handleInputChange.bind(this, 'DisplayName')}/>
              </div>

              <div className="form-group">
                  <label>{t('CIP Group')}</label>
                  <Select disabled={!Authorized} 
                    value={this.state.user.CipGroupId}
                    options={cipGroups.Groups} onChange={this.handleCipGroupSelect.bind(this)}
                  />
              </div>
             <div className="checkbox">
                  <label><input type="checkbox" disabled={!IsAdmin} checked={stateUser.IsAdmin || false} onChange={this.handleInputChange.bind(this, 'IsAdmin')}/>
                  {t('Is Admin')}</label>
              </div>
              <div className="checkbox">
                  <label><input type="checkbox" disabled={!IsAdmin} checked={stateUser.IsActive || false} onChange={this.handleInputChange.bind(this, 'IsActive')}/>
                  {t('Is Active')}</label>
              </div>
            
              

              <Collapse in={this.state.errorOpen || false}>
                <Alert bsStyle="danger">
                  <strong>{t('Error')}!</strong> {t(this.state.errorMessage)}
                </Alert>
              </Collapse>
              
              {
                  Authorized &&
                <button disabled={!(stateUser.DisplayName && stateUser.Account) || false } type="button" onClick={this.saveUserClick.bind(this)} className="btn btn-default btn-brand pull-right">
                  {t('Save')}</button>
              }
            </form>
        </Panel>
      </div>
    );
  }
}

UserEditPage.displayName = 'UserEditPage';
UserEditPage.propTypes = {};
UserEditPage.defaultProps = {};
export default injectIntl(cssmodules(UserEditPage, styles));



// WEBPACK FOOTER //
// ./components/Users/UserEditPage.js